// Central data source for Vinařství Brychta.
// Edit this file to change texts, prices, contact data, wines, reviews and images.
// See /app/README-CONTENT.md for a plain-language guide.

export const business = {
  wineryName: "Vinařství Brychta",
  accommodationName: "Ubytování u vinaře",
  address: {
    street: "Tyršův sad 395/5",
    city: "Břeclav 6 – Charvátská Nová Ves",
    postal: "690 06",
    country: "Česká republika",
  },
  phone: "+420 607 872 849",
  phoneHref: "+420607872849",
  emails: {
    winery: "info@vinarstvibrychta.cz",
    accommodation: "info@ubytovaniuvinare.cz",
  },
  websites: {
    winery: "https://vinarstvibrychta.cz/",
    accommodation: "https://www.ubytovaniuvinare.cz/",
  },
  google: {
    profileUrl:
      "https://www.google.com/maps/place/Ubytov%C3%A1n%C3%AD+u+vina%C5%99e/@48.7650435,16.8460882,17z/data=!4m11!3m10!1s0x476d2ac5193af195:0x92bf9dbcd94a5c11!5m2!4m1!1i2!8m2!3d48.7645376!4d16.8462571!9m1!1b1!16s%2Fg%2F11c74ff165",
    rating: 4.9,
    ratingsCount: 39,
  },
  socials: {
    // Leave empty to hide icons. Do NOT invent URLs.
    instagram: "",
    facebook: "",
  },
  brandStatement:
    "Rodinné vinařství, ubytování a autentické zážitky u vína kousek od Lednice.",
};

// Provozovatelé – dvě samostatné podnikající fyzické osoby sdílející veřejnou značku „Vinařství Brychta".
// Uvádí se pouze v právních textech a v patičce, ne v marketingových prvcích ani v hlavičce.
export const operators = {
  accommodation: {
    role: "Ubytování u vinaře",
    name: "Alice Brychtová",
    ico: "75647672",
    registeredAddress: {
      street: "SNP 751/10",
      city: "Břeclav – Charvátská Nová Ves",
      postal: "690 06",
    },
    // Skutečné místo poskytování ubytování se liší od zapsané adresy podnikání.
    operatingAddress: {
      street: "Tyršův sad 395/5",
      city: "Břeclav – Charvátská Nová Ves",
      postal: "690 06",
    },
    email: "info@ubytovaniuvinare.cz",
    phone: "+420 607 872 849",
  },
  winery: {
    role: "Prodej vína a degustace",
    name: "Miloslav Brychta",
    ico: "11810491",
    registeredAddress: {
      street: "Lednická 237/126",
      city: "Břeclav – Charvátská Nová Ves",
      postal: "690 06",
    },
    email: "info@vinarstvibrychta.cz",
    phone: "+420 607 872 849",
  },
};

export const images = {
  hero: "https://images.unsplash.com/photo-1543418219-44e30b057fea?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  intro: "https://images.pexels.com/photos/35494398/pexels-photo-35494398.jpeg?auto=compress&cs=tinysrgb&w=1600",
  featuredWeekend: "https://images.unsplash.com/photo-1470158499416-75be9aa0c4db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  audiences: {
    couples: "https://images.pexels.com/photos/7447405/pexels-photo-7447405.jpeg?auto=compress&cs=tinysrgb&w=1200",
    cyclists: "https://images.unsplash.com/photo-1517649763962-0c623066013b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    families: "https://images.pexels.com/photos/30070551/pexels-photo-30070551.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  familyPortrait: "https://images.unsplash.com/photo-1669711517916-9c0767aaa08b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  wineTeaser: "https://images.pexels.com/photos/14173932/pexels-photo-14173932.jpeg?auto=compress&cs=tinysrgb&w=1200",
  gallery: [
    { src: "https://images.unsplash.com/photo-1543418219-44e30b057fea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", alt: "Vinohrad při západu slunce", cat: "Vinohrad" },
    { src: "https://images.pexels.com/photos/7447405/pexels-photo-7447405.jpeg?auto=compress&cs=tinysrgb&w=1600", alt: "Degustace vína", cat: "Degustace" },
    { src: "https://images.pexels.com/photos/30070551/pexels-photo-30070551.jpeg?auto=compress&cs=tinysrgb&w=1600", alt: "Apartmán interiér", cat: "Ubytování" },
    { src: "https://images.unsplash.com/photo-1686604585343-9da1b400c7a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", alt: "Ložnice", cat: "Ubytování" },
    { src: "https://images.pexels.com/photos/14173932/pexels-photo-14173932.jpeg?auto=compress&cs=tinysrgb&w=1600", alt: "Sklenice bílého vína", cat: "Naše vína" },
    { src: "https://images.unsplash.com/photo-1470158499416-75be9aa0c4db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", alt: "Nalévané víno", cat: "Vinařství" },
    { src: "https://images.pexels.com/photos/34635706/pexels-photo-34635706.jpeg?auto=compress&cs=tinysrgb&w=1600", alt: "Piknik ve vinohradě", cat: "Zážitky" },
    { src: "https://images.pexels.com/photos/35494398/pexels-photo-35494398.jpeg?auto=compress&cs=tinysrgb&w=1600", alt: "Krajina jižní Moravy", cat: "Vinohrad" },
    { src: "https://images.pexels.com/photos/30767888/pexels-photo-30767888.jpeg?auto=compress&cs=tinysrgb&w=1600", alt: "Detail apartmánu", cat: "Ubytování" },
  ],
};

export const experiences = [
  {
    slug: "rizena-degustace",
    showTastingVariants: true,
    title: "Řízená degustace vín",
    short: "Ochutnávka našich vín s výkladem o odrůdách, práci ve vinohradě a výrobě vína. Součástí je bohaté občerstvení.",
    duration: "Přibližně 1–3 hodiny podle varianty",
    audience: "Páry, přátelé, skupiny i hosté ubytování",
    price: "Od 300 Kč za osobu",
    cta: "Prohlédnout degustace",
    image: "https://images.pexels.com/photos/7447405/pexels-photo-7447405.jpeg?auto=compress&cs=tinysrgb&w=1600",
    featured: true,
    enquiryType: "degustace",
    intro:
      "Provedeme vás naší kolekcí vín. Vysvětlíme, jaké odrůdy pěstujeme, co v daném roce ovlivnilo úrodu a co se dělo ve sklepě. Ochutnáte několik vzorků a k nim dostanete bohaté občerstvení.",
    included: [
      "5–12 vzorků podle varianty",
      "Osobní výklad od vinaře",
      "Bohaté občerstvení (masné a sýrové prkénko podle domluvené varianty)",
    ],
    notes: [
      "Degustaci připravíme i pro páry po předchozí domluvě.",
      "Za menší počet účastníků neúčtujeme příplatek.",
      "Konání celoročně po domluvě.",
    ],
  },
  {
    slug: "degustace-ve-vinohrade",
    title: "Degustace ve vinohradě",
    short: "Ochutnávka vína mezi řádky révy v atmosféře jihomoravského vinohradu. Provedení závisí na počasí a sezoně.",
    duration: "Přibližně 90 minut",
    audience: "Páry a menší skupiny",
    price: "Cena podle počtu osob a programu",
    cta: "Zjistit podrobnosti",
    image: "https://images.pexels.com/photos/34635706/pexels-photo-34635706.jpeg?auto=compress&cs=tinysrgb&w=1600",
    featured: true,
    enquiryType: "degustace",
    intro:
      "Vyjdeme s vámi přímo do vinohradu. Ochutnáte několik vzorků mezi řádky révy, ukážeme, jak vinohrad v dané části roku vypadá, a povíme, co nás v následujících týdnech čeká.",
    included: [
      "Krátká procházka vinohradem",
      "Ochutnávka vybraných vzorků na místě",
      "Malé občerstvení",
    ],
    notes: [
      "Konání je závislé na počasí a stavu vinohradu.",
      "Náhradní termín nebo přesun do sklepa domlouváme individuálně.",
    ],
  },
  {
    slug: "piknik-ve-vinohrade",
    title: "Piknik ve vinohradě",
    short: "Připravené místo ve vinohradě s vínem, domácí limonádou a občerstvením. Obsah pikniku přizpůsobíme domluvené variantě.",
    duration: "Přibližně 2–3 hodiny",
    audience: "Páry, rodiny a dárkové pobyty",
    price: "Cena podle zvolené varianty",
    cta: "Naplánovat piknik",
    image: "https://images.pexels.com/photos/34635706/pexels-photo-34635706.jpeg?auto=compress&cs=tinysrgb&w=1600",
    enquiryType: "piknik",
    intro:
      "Připravíme pro vás piknik přímo mezi vinicemi. Obsah přizpůsobíme tomu, jestli přijíždíte v páru, s dětmi nebo s přáteli, a jestli chcete kombinovat víno, nealko nebo bezalkoholové varianty.",
    included: [
      "Deka, koše a připravené místo",
      "Víno nebo domácí limonáda",
      "Občerstvení podle domluvy",
    ],
    notes: [
      "Konání je závislé na počasí; při nepřízni volíme náhradní termín nebo krytou variantu.",
    ],
  },
  {
    slug: "pobyt-u-vinare",
    title: "Pobyt u vinaře",
    short: "Ubytování v jednom ze tří apartmánů, láhev vína na uvítanou a možnost doplnit pobyt o degustaci nebo program v okolí.",
    duration: "Minimálně 2 noci",
    audience: "Páry, rodiny, turisté a cyklisté",
    price: "500 Kč / osoba / noc",
    cta: "Prohlédnout ubytování",
    image: "https://images.pexels.com/photos/30070551/pexels-photo-30070551.jpeg?auto=compress&cs=tinysrgb&w=1600",
    featured: true,
    enquiryType: "ubytovani",
    intro:
      "Ubytujete se v jednom ze tří apartmánů v Charvátské Nové Vsi. Uvítá vás láhev našeho vína a klidné prostředí kousek od Lednice a Valtic.",
    included: [
      "Ubytování v jednom ze tří apartmánů",
      "Uvítací láhev vína",
      "Doporučení výletů a tras",
      "Bezpečné uzamčené odkládání kol",
    ],
    notes: [
      "Minimální délka pobytu jsou 2 noci.",
      "Konkrétní apartmán potvrzujeme podle dostupnosti a počtu osob.",
      "Místní poplatek z pobytu není zahrnut v ceně.",
    ],
  },
  {
    slug: "rodinny-pobyt-na-jizni-morave",
    title: "Rodinný pobyt na jižní Moravě",
    short: "Pět nocí pro čtyřčlennou rodinu, výlety po jižní Moravě a sedmivzorková degustace ve vinohradě pro rodiče.",
    duration: "5 nocí",
    audience: "Rodiny se dvěma dětmi",
    price: "9 990 Kč / pobyt",
    priceNote: "Cena platí pro 4 osoby a 5 nocí.",
    cta: "Poptat rodinný pobyt",
    image: "",
    featured: true,
    enquiryType: "vinarsky_pobyt",
    prefillMessage: "Rodinný pobyt na jižní Moravě",
    // Balíček je definovaný pro 4 osoby (2 dospělí + 2 děti) – použije se pouze zde,
    // běžnou poptávku ubytování neovlivňuje.
    prefillAdults: 2,
    prefillChildren: 2,
    intro:
      "Pět nocí pro čtyřčlennou rodinu, pohodové výlety po jižní Moravě a sedmivzorková degustace ve vinohradě pro rodiče. Dětem připravíme nealkoholické nápoje a společné občerstvení.",
    included: [
      "5 nocí ubytování pro 4 osoby",
      "Vhodný apartmán podle aktuální dostupnosti",
      "Sedmivzorková degustace ve vinohradě pro 2 dospělé",
      "Nealkoholické nápoje pro 2 děti",
      "Společné občerstvení během degustace",
      "Láhev vína na uvítanou",
      "Bezpečné uložení kol",
      "Doporučení rodinných výletů a cyklotras",
    ],
    notes: [
      "Cena 9 990 Kč platí celoročně pro 4 osoby a 5 nocí.",
      "Program ve vinohradě závisí na počasí, náhradu domlouváme individuálně.",
      "Místní poplatek z pobytu není v ceně.",
      "Rezervaci potvrzujeme osobně.",
    ],
  },
  {
    slug: "firemni-akce",
    title: "Firemní večer a teambuilding",
    short: "Degustace, občerstvení, neformální posezení a doprovodný program sestavený podle velikosti týmu a cíle akce.",
    duration: "Podle domluvy",
    audience: "Firmy, pracovní týmy a obchodní partneři",
    price: "Individuální nabídka",
    cta: "Poptat firemní akci",
    image: "https://images.pexels.com/photos/7447405/pexels-photo-7447405.jpeg?auto=compress&cs=tinysrgb&w=1600",
    enquiryType: "firemni_akce",
    intro:
      "Připravíme program pro váš tým nebo obchodní partnery. Konkrétní obsah, délku i formu domlouváme individuálně podle velikosti skupiny a cíle akce.",
    included: [
      "Řízená degustace",
      "Občerstvení podle domluvy",
      "Neformální posezení v prostředí vinařství",
    ],
    notes: [
      "Kapacita, program a cena vzniká individuálně.",
      "Rádi doporučíme ubytování pro celý tým.",
    ],
  },
  {
    slug: "soukrome-oslavy",
    title: "Soukromé oslavy",
    short: "Menší narozeniny, rodinná setkání a večery s přáteli v příjemné vinařské atmosféře.",
    duration: "Podle domluvy",
    audience: "Rodiny a uzavřené skupiny",
    price: "Individuální nabídka",
    cta: "Poptat oslavu",
    image: "https://images.pexels.com/photos/30767888/pexels-photo-30767888.jpeg?auto=compress&cs=tinysrgb&w=1600",
    enquiryType: "soukroma_oslava",
    intro:
      "Připravíme prostředí pro vaši oslavu – narozeniny, výročí, rodinné setkání nebo večer s přáteli. Menu, víno a program domlouváme s vámi.",
    included: [
      "Prostor a posezení",
      "Víno z našeho vinařství",
      "Občerstvení podle domluvy",
    ],
    notes: ["Kapacita a rozsah domlouváme individuálně."],
  },
  {
    slug: "sezonni-zazitky",
    title: "Sezonní zážitky",
    short: "Burčák, vinobraní, práce ve vinohradě a nahlédnutí do výroby vína podle aktuální části vinařského roku.",
    duration: "Podle sezony",
    audience: "Milovníci vína, turisté a zážitkové skupiny",
    price: "Podle konkrétního programu",
    cta: "Poznat vinařský rok",
    image: "https://images.pexels.com/photos/35494398/pexels-photo-35494398.jpeg?auto=compress&cs=tinysrgb&w=1600",
    enquiryType: "sezonni_zazitek",
    intro:
      "Během roku se ve vinohradě i ve sklepě dějí různé věci. Umožňujeme hostům nahlédnout do vinařského roku – od jarní práce, přes vinobraní až po burčák.",
    included: [
      "Program podle aktuální části vinařského roku",
      "Ochutnávka spojená s tématem",
    ],
    notes: ["Konkrétní program se mění podle sezony. Napište nám, kdy plánujete přijet."],
  },
];

export const apartments = [
  {
    slug: "modry-apartman",
    name: "Modrý apartmán",
    capacity: "Až 7 osob",
    capacityNumber: 7,
    summary: "Prostorný apartmán vhodný pro rodiny a větší skupiny.",
    minNights: 2,
    image: "https://images.pexels.com/photos/30070551/pexels-photo-30070551.jpeg?auto=compress&cs=tinysrgb&w=1600",
    gallery: [
      "https://images.pexels.com/photos/30070551/pexels-photo-30070551.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.unsplash.com/photo-1686604585343-9da1b400c7a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.pexels.com/photos/30767888/pexels-photo-30767888.jpeg?auto=compress&cs=tinysrgb&w=1600",
    ],
    equipment: [],
  },
  {
    slug: "cerveny-apartman",
    name: "Červený apartmán",
    capacity: "3 + 1 přistýlka",
    capacityNumber: 4,
    summary: "Útulný apartmán pro menší rodinu nebo přátele.",
    minNights: 2,
    image: "https://images.unsplash.com/photo-1686604585343-9da1b400c7a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    gallery: [
      "https://images.unsplash.com/photo-1686604585343-9da1b400c7a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.pexels.com/photos/30767888/pexels-photo-30767888.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/30070551/pexels-photo-30070551.jpeg?auto=compress&cs=tinysrgb&w=1600",
    ],
    equipment: [],
  },
  {
    slug: "modrotiskovy-apartman",
    name: "Modrotiskový apartmán",
    capacity: "2 + 1 přistýlka",
    capacityNumber: 3,
    summary: "Menší apartmán pro páry, případně s jedním dítětem.",
    minNights: 2,
    image: "https://images.pexels.com/photos/30767888/pexels-photo-30767888.jpeg?auto=compress&cs=tinysrgb&w=1600",
    gallery: [
      "https://images.pexels.com/photos/30767888/pexels-photo-30767888.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.pexels.com/photos/30070551/pexels-photo-30070551.jpeg?auto=compress&cs=tinysrgb&w=1600",
      "https://images.unsplash.com/photo-1686604585343-9da1b400c7a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    ],
    equipment: [],
  },
];

// Autoritativní pravidla cenotvorby ubytování. Sjednoceno pro všechny apartmány.
export const pricingRules = {
  perPersonSummer: 500,     // Kč / osoba / noc mimo zimní období
  perPersonWinter: 600,     // Kč / osoba / noc v zimním období
  // Zimní období = 1. 11. – 31. 3. včetně
  isWinterDate(dateStr) {
    if (!dateStr) return false;
    const d = new Date(dateStr);
    const m = d.getMonth() + 1; // 1–12
    return m >= 11 || m <= 3;
  },
  perPersonForDate(dateStr) {
    return this.isWinterDate(dateStr) ? this.perPersonWinter : this.perPersonSummer;
  },
};

export const accommodationConditions = {
  perPersonSummer: 500,
  perPersonWinter: 600,
  localFee: "25 Kč / osoba nad 18 let / noc (není zahrnuto)",
  minNights: 2,
  checkIn: "od 14:00",
  checkOut: "do 10:00",
  pets: "Zvířata nejsou povolena.",
  parking: "Parkování zdarma.",
  bicycleStorage: "Sdílený prostor cca pro 14 kol.",
  deposit: "50% záloha, splatná zpravidla do 3 dnů od potvrzení.",
  payment: "Bankovní převod, QR platba, hotovost nebo karta – podle domluvy.",
  children: "Podrobnosti upřesníme při potvrzení pobytu.",
  seasonSummer: "duben–říjen",
  seasonWinter: "listopad–březen",
};

export const tastings = [
  { slug: "kratka", name: "Krátká degustace", samples: "5–7 vzorků", duration: "cca 1 hodina", price: 300, priceVineyard: 350 },
  { slug: "rozsirena", name: "Rozšířená degustace", samples: "8–10 vzorků", duration: "až 2 hodiny", price: 450, priceVineyard: 500 },
  { slug: "velka", name: "Velká degustace", samples: "až 12 vzorků", duration: "až 180 minut", price: 600, priceVineyard: 650 },
];

export const tastingConditions = {
  minParticipants: "Degustaci připravíme i pro páry, vždy po předchozí domluvě.",
  smallGroups: "Za menší počet účastníků neúčtujeme příplatek.",
  bigGroups: "U větších skupin potvrdíme kapacitu individuálně.",
  vineyardSurcharge: "Stejné varianty ve vinohradě mají příplatek 50 Kč / osoba.",
  privateCouple: "Soukromá degustace pro pár používá stejný ceník za osobu, bez příplatku.",
  openTo: "Degustace jsou dostupné hostům ubytování i lidem, kteří u nás nebydlí.",
  season: "Konání celoročně po předchozí domluvě.",
  board: "Občerstvení je zahrnuto v ceně. Jeho rozsah a skladba odpovídají zvolené variantě degustace.",
};

const W25 = { vintage: "2025", category: "moravské zemské víno", region: "Jižní Morava", volume: "0,75 l", price: 150 };

// Static fallback; live data is managed in /admin (Vína) and loaded from /api/wines.
export const wines = [
  { slug: "palava", name: "Pálava", ...W25, sweetness: "suché", alcohol: "12,8 %" },
  { slug: "veltlinske-zelene", name: "Veltlínské zelené", ...W25, sweetness: "suché", alcohol: "12,2 %" },
  { slug: "rulandske-bile", name: "Rulandské bílé", ...W25, sweetness: "polosuché", alcohol: "12,0 %" },
  { slug: "muller-thurgau", name: "Müller Thurgau", ...W25, sweetness: "suché", alcohol: "12,5 %" },
  { slug: "bryzzante-white", name: "Bryzzante White", volume: "0,75 l", price: 150 },
  { slug: "bryzzante-rose", name: "Bryzzante Rosé", volume: "0,75 l", price: 150 },
  { slug: "hibernal", name: "Hibernal", ...W25, sweetness: "suché", alcohol: "12,5 %" },
  { slug: "souvignier-gris", name: "Souvignier Griss", ...W25, sweetness: "suché", alcohol: "12,0 %" },
  { slug: "donau-riesling", name: "Donauriesling", ...W25, sweetness: "polosuché", alcohol: "11,5 %" },
  { slug: "ryzlink-vlassky", name: "Ryzlink vlašský", ...W25, sweetness: "suché", alcohol: "12,0 %" },
  { slug: "frankovka", name: "Frankovka", volume: "0,75 l", price: 150 },
  { slug: "dornfelder", name: "Dornfelder", ...W25, alcohol: "12,5 %" },
  { slug: "andre", name: "André", ...W25, alcohol: "12,5 %" },
  { slug: "frankovka-2022", name: "Frankovka 2022", vintage: "2022", volume: "0,75 l", price: 150 },
];

export const reviews = [
  { name: "Adam Housírek", rating: 5, text: "Nikde na světě jsem nezažil takhle krásný přístup k hostům. Pokoje byly čisté, uklizené a vybavené." },
  { name: "Lucie Simonidesová", rating: 5, text: "Čisté, moc hezké, hezky zařízené. Kousek od Břeclavi, ideální na cyklovýlety do Lednicko-valtického areálu." },
  { name: "Jana Vlková", rating: 5, text: "Příjemné prostředí, možnost zakoupení vína přímo od vinaře. Apartmán je dostatečně vybavený a majitel je milý a vstřícný." },
  { name: "Michal Bejvl", rating: 5, text: "Krásné ubytování pro čtyři rodiny s dětmi, v okolí krásná příroda a jako bonus sklípek s dobrým vínem." },
];

export const faq = [
  { q: "Je nutná rezervace předem?", a: "Ano, degustace i zážitky vždy plánujeme s předstihem. Napište nám termín a počet osob a ozveme se s konkrétní nabídkou." },
  { q: "Pro kolik lidí jsou degustace vhodné?", a: "Degustaci připravíme i pro páry, vždy po předchozí domluvě. Cena za osobu se řídí zvolenou variantou a za menší počet účastníků neúčtujeme příplatek. U větších skupin potvrdíme kapacitu individuálně." },
  { q: "Lze připravit soukromou degustaci pro pár?", a: "Ano, po předchozí domluvě připravíme i soukromou degustaci pro pár. Ve sklepě zaplatíte podle zvolené varianty 300, 450 nebo 600 Kč za osobu, bez příplatku za menší počet účastníků. Degustace ve vinohradě stojí o 50 Kč za osobu více." },
  { q: "Mohou přijet i lidé, kteří u vás nebydlí?", a: "Ano, degustace jsou otevřené i hostům, kteří u nás nejsou ubytovaní." },
  { q: "Co se stane při špatném počasí?", a: "U venkovních zážitků domlouváme individuálně náhradní termín nebo alternativu ve sklepě či v jiných vnitřních prostorech." },
  { q: "Je možné bezpečně uložit kola?", a: "Ano, k dispozici je sdílený prostor cca pro 14 kol." },
  { q: "Je možné přijet se psem?", a: "Pobyt domácích mazlíčků není v apartmánu povolen." },
  { q: "Jak se potvrzuje rezervace ubytování?", a: "Po odeslání poptávky se vám ozveme s konkrétní nabídkou. Rezervace se stává závaznou po uhrazení 50% zálohy." },
  { q: "Jak funguje objednávka vína?", a: "Vyplněná poptávka není automaticky potvrzenou objednávkou. Dostupnost, způsob převzetí a konečnou cenu vám potvrdíme osobně." },
  { q: "Připravujete program pro firmy?", a: "Ano. Firemní večery, teambuildingy a programy pro obchodní partnery připravujeme individuálně." },
  { q: "Lze koupit dárkový poukaz?", a: "Ano. Vyplňte objednávku na stránce Dárkový poukaz – po potvrzení vám pošleme PDF k vytištění na e-mail. Platnost 12 měsíců." },
];

export const enquiryTypes = [
  { value: "ubytovani", label: "Ubytování" },
  { value: "degustace", label: "Degustace" },
  { value: "vinarsky_pobyt", label: "Vinařský pobyt" },
  { value: "piknik", label: "Piknik" },
  { value: "firemni_akce", label: "Firemní akce" },
  { value: "soukroma_oslava", label: "Soukromá oslava" },
  { value: "sezonni_zazitek", label: "Sezonní zážitek" },
  { value: "objednavka_vina", label: "Objednávka vína" },
  { value: "darkovy_poukaz", label: "Dárkový poukaz" },
  { value: "jiny_dotaz", label: "Jiný dotaz" },
];

export const apartmentPreferences = [
  { value: "modry-apartman", label: "Modrý apartmán" },
  { value: "cerveny-apartman", label: "Červený apartmán" },
  { value: "modrotiskovy-apartman", label: "Modrotiskový apartmán" },
  { value: "nemam-preferenci", label: "Nemám preferenci" },
];

export const seo = {
  siteName: "Vinařství Brychta",
  baseUrl: "https://vinarstvibrychta.cz",
  homeTitle: "Vinařské zážitky, degustace a ubytování u Lednice | Vinařství Brychta",
  homeDescription:
    "Rodinné vinařství v Charvátské Nové Vsi. Degustace, vinařské pobyty, pikniky, ubytování a firemní programy kousek od Lednice.",
  ogImage: "https://images.unsplash.com/photo-1543418219-44e30b057fea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const analytics = {
  gtmId: process.env.REACT_APP_GTM_ID || "",
  gaId: process.env.REACT_APP_GA_ID || "",
  adsId: process.env.REACT_APP_ADS_ID || "",
  metaPixelId: process.env.REACT_APP_META_PIXEL_ID || "",
};
